import React, { useCallback, forwardRef } from 'react'
import { useDispatch } from 'react-redux'
import Actions from '../../../actions'
import { eventTypes, event } from '../../../consts/eventConsts'

import './UploadDocumentsAction.css'

const UploadDocumentsAction = forwardRef((props, ref) => {
  const dispatch = useDispatch()
  const inputFile = ref

  const onFileSelected = e => {
    // get the files
    const file = e.target.files?.[0]

    // Make new FileReader
    const reader = new FileReader()
    // Convert the file to base64 text
    if (file) {
      reader.readAsDataURL(file)
    }
    // on reader load somthing...
    reader.onload = () => {
      // Make a fileInfo Object
      const fileInfo = {
        name: file.name,
        type: file.type,
        size: Math.round(file.size / 1000) + ' kB',
        base64: reader.result.split(',')[1],
        file: file
      }
      // Send only metadata to analytics, not the actual file content
      dispatch(
        Actions.createAction(Actions.ANALYTICS_EVENT_FIRED, {
          type: eventTypes.formEvent,
          eventName: event.botEvent.submit,
          element: 'Upload files',
          data: {
            name: fileInfo.name,
            type: fileInfo.type,
            size: fileInfo.size
          }
        })
      )
      dispatch(
        Actions.createAction(Actions.UPLOAD_FILE_REQUESTED, { data: fileInfo })
      )
    } // reader.onload
  }

  return (
    <input
      type='file'
      name='file'
      ref={inputFile}
      accept='.xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf'
      style={{ display: 'none' }}
      onChange={onFileSelected}
    />
  )
})

export default UploadDocumentsAction
